import { useEffect, useState } from "react";
import { type Column } from "@/types/array.types"
import "./admin-users.css"
import { formatDateDisplay } from "@/utils/date";
import { createUser, deleteUser, getProfiles, getRoles, updateUser, type CreateUserType, type ProfileType, type ProfileTypeWithRole, type Role } from "./viewModel";
import { UsersTable } from "../../components/users-table";
import { Button } from "@/components/button";
import Drawer from "@/components/drawer/Drawer";
import { CreateUserForm } from "../../components/create-user-form/CreateUserForm";
import ConfirmModal from "@/components/modal/Modal";



export default function AdminUsers() {

  const [open, setOpen] = useState(false);
  const [roles, setRoles] = useState<Role[]>([]);  
  const [users, setUsers] = useState<any[]>([]);
  const [uuid, setUuid] = useState("");
  const [isDeleteOpen, setDeleteOpen] = useState(false); 

  const columns = [
    {
      key: "full_name",
      label: "Nom",
    },
    {
      key: "roles",
      label: "Role",
      render: (row) => row.roles?.name ?? ""
    },
    {
      key: "is_active",
      label: "Actif",
      render: (row) => row.is_active ? "Oui" : "Non"
    },
    {
      key: "created_at",
      label: "Date de création",
      render: (row) => row ? formatDateDisplay(row.created_at) : "",
    },
    {
      key: "last_login",
      label: "Dernière connexion",
      render: (row) => row ? formatDateDisplay(row.last_login_at) : "",
    },
  ] as Column<ProfileTypeWithRole>[];

  const loadUsers = async () => {
    const data = await getProfiles();
    setUsers(data ?? []);
  };

  const loadRoles = async () => {
    const data = await getRoles();
    setRoles(data ?? []);
  };


  useEffect(() => {
    loadRoles();
    loadUsers();
  }, []);

  const onUpdate = async(id: string, values: Partial<ProfileType>) => {
    await updateUser(id, values);
  };

  const onAdd = () => {
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
  };

  const onCreate = async (values: CreateUserType) => {
    await createUser(values);
    await loadUsers();
    setOpen(false);
  };

  const onDelete = async (id: string) => {
    await deleteUser(id);
    await loadUsers();
  };

  return (
    <section className="admin-section">
  
      <h2>Utilisateurs</h2>
      <div className="admin-user-create">
        <Button label={"Ajouter un nouvel utilisateur"} leftIcon="add" onClick={onAdd}></Button>
      </div>
      <UsersTable
        users={users}
        columns={columns}
        roles={roles}
        onDelete={(id) => {
          setDeleteOpen(true);
          setUuid(id)}}
        onUpdate={onUpdate}
      />
       <Drawer
          isOpen={open}
          title={"Nouvel utilisateur"}
          onClose={() => setOpen(false)}
        >
          <CreateUserForm<CreateUserType> roles={roles} onCancel={onCancel} onSubmit={onCreate}/>
        </Drawer>
        <ConfirmModal
          isOpen={isDeleteOpen}
          title="Supprimer cet utilisateur ?"
          message={
              <>
                  Cette action est <strong>définitive</strong>.
                  <br />
                  Les données seront supprimées de la base.
              </>
          }
          onCancel={() => setDeleteOpen(false)}
          onConfirm={() => {
            onDelete(uuid);
            setDeleteOpen(false);
          }}
        />
    </section>
  );
}